import { CreateExperienceKeyMetricDto } from "@intelligems/ig-types/dtos/experience-key-metrics";
import { ExperienceKeyMetricFe } from "@intelligems/ig-types/fe-only/custom-events";
import {
  STANDARD_EVENTS_ALLOWED_KEY_METRICS,
  StandardEventAllowedKeyMetrics,
  StandardEventDto,
} from "@intelligems/ig-types/dtos/analytics-events/standard-events";
import { StandardKeyMetrics } from "@src/types/standard-events";

export const sortStandardEvents = (
  filteredKeys: Record<
    Partial<StandardEventAllowedKeyMetrics>,
    StandardEventDto
  >
) => {
  const sortedMetrics: Record<string, StandardEventDto[]> = {};
  // Iterate over the groups and their corresponding metrics in StandardKeyMetrics
  for (const [group, keys] of Object.entries(StandardKeyMetrics)) {
    sortedMetrics[group] = keys
      .map((key) => filteredKeys[key]) // Map keys to the metrics
      .filter((metric) => metric !== undefined); // Filter out undefined (in case of missing keys)
  }

  return sortedMetrics;
};

export const initExperienceKeyMetricFromStandardEvent = (
  standardEvents: StandardEventAllowedKeyMetrics[],
  startIndex: number
): CreateExperienceKeyMetricDto[] => {
  return standardEvents.map((standardEvent, index) => ({
    standardEventId: standardEvent,
    customEventId: null,
    customEvent: null,
    order: startIndex + index,
    isPrimary: false,
  }));
};

export function filterEventsByNameDescription(
  events: typeof STANDARD_EVENTS_ALLOWED_KEY_METRICS,
  searchTerm: string
): typeof STANDARD_EVENTS_ALLOWED_KEY_METRICS {
  return Object.fromEntries(
    Object.entries(events).filter(
      ([_, event]) =>
        event.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (event.description || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
    )
  ) as typeof STANDARD_EVENTS_ALLOWED_KEY_METRICS;
}

export const getKeyMetricName = (keyMetric: ExperienceKeyMetricFe) => {
  return keyMetric?.experienceCustomMetricId
    ? keyMetric.experienceCustomMetric?.customEvent?.name || ""
    : STANDARD_EVENTS_ALLOWED_KEY_METRICS[keyMetric.standardEventId!]?.name ||
        "";
};
